<template>
  <a-card :bordered="false">
    <a-form>
      <search-header :col="3">
        <search-list>
          <template v-if='listType===1'>
            <a-form-item label="合同名称" v-bind="searchItemLayout">
              <a-input v-model="queryParams.pactName" placeholder="请输入合同名称"></a-input>
            </a-form-item>
            <a-form-item label="签署方名称" v-bind="searchItemLayout">
              <a-input v-model="queryParams.signName" placeholder="请输入签署方名称"></a-input>
            </a-form-item>
          </template>
          <template v-else>
            <a-form-item label="模板名称" v-bind="searchItemLayout">
              <a-input v-model="queryParams.pactName" placeholder="请输入模板名称"></a-input>
            </a-form-item>
          </template>
          <a-form-model-item style="margin-left:10%;">
            <a-button type="primary" @click="onEventRefresh">查询</a-button>
          </a-form-model-item>
        </search-list>
      </search-header>
    </a-form>
    <a-row>
      <a-col :span="12">
        <a-radio-group style="margin-bottom: 20px" v-model="listType">
          <a-radio-button :value="1">合同列表</a-radio-button>
          <a-radio-button :value="2">合同模版</a-radio-button>
        </a-radio-group>
        <div class='inline-box'>
          <a-button v-if="listType===1" type="primary" @click="addContractEvent">新增合同</a-button>
          <a-button v-else type="primary" @click="addTemplateEvent">新增模版</a-button>
        </div>
      </a-col>
      <a-col :offset="12">
        <div class='right-setting'>
          <span style='margin-right: 15px'>对接全国旅游监督平台</span>
          <a @click="onPlatformSettingEvent">设置</a>
        </div>
      </a-col>
    </a-row>
    <custom-page-table
      ref="tableList"
      :size="'default'"
      :queryParams="queryParams"
      :columns="listType===1?getContractColumns():getTemplateColumns()"
      :request-promise="getRequestPromise"
    >
      <template slot="pactSignStatus" slot-scope="rowItem">{{ rowItem.text == 0 ? '未签署' : '已签署' }}</template>
      <template slot="action" slot-scope="rowItem">
        <a @click="preViewContractEvent(rowItem.record)">预览</a>
        <a-divider type="vertical"/>
        <span v-show="listType===1">
          <a v-show="rowItem.record.pactSignStatus==0" @click="resendEvent(rowItem.record)">重发提醒</a>
          <a v-show="rowItem.record.pactSignStatus==1" @click="downLoadEvent(rowItem.record)">下载合同</a>
        </span>
        <span v-show="listType===2">
          <template v-if='rowItem.record.preBuilder==0'>
            <a @click="editTemplateEvent(rowItem.record)">编辑</a>
            <a-divider type="vertical"/>
          </template>
          <a @click='copyTemplate(rowItem.record)'>复制</a>
        </span>
      </template>
    </custom-page-table>
    <a-modal v-if="preViewDialogVisible" v-model="preViewDialogVisible" :footer="null" width="800px">
      <div style="padding-top: 20px">
        <custom-pdf-viewer :url="preViewPdfUrl" :isBoolean='true'></custom-pdf-viewer>
      </div>
    </a-modal>
    <a-modal width="800px" v-model="showMsgDialog" :footer="null">
      <a-tabs style="background-color: white;" v-model="selectedIndex">
        <a-tab-pane v-for="(item,index) in msgList" :tab="item.signName" :key="index">
          <a-row>
            <a-col :span="3"><span>短信内容：</span></a-col>
            <a-col :span="21" @click="copySmsContent(item.smsContent)">
              <a-textarea :disabled="true" :value="item.smsContent"></a-textarea>
            </a-col>
          </a-row>
          <span style="float: right;margin-top: 20px">
              <a-button @click="confirmSending(0)">取消</a-button>
              <a-button type="primary" @click="confirmSending(1)" :loading="sendLoading"
                        style="margin-left: 20px">重发短信</a-button>
          </span>
        </a-tab-pane>
      </a-tabs>
    </a-modal>
    <a-modal title='对接设置' width="700px" :visible="settingVisible"
             @ok="handleSettingOk"
             :confirm-loading="confirmLoading"
             @cancel="handleSettingCancel">
      <a-form-model :label-col="{span:4}" :wrapper-col="{span:16}" ref="ruleForm" :model="ruleForm"
                    :rules="platformSettingRules">
        <a-form-model-item label="AppId" prop="appId">
          <a-input v-model="ruleForm.appId" placeholder="请输入" :maxLength='100'></a-input>
        </a-form-model-item>
        <a-form-model-item label="signKey" prop="signKey">
          <a-input v-model="ruleForm.signKey" placeholder="请输入" :maxLength='100'></a-input>
        </a-form-model-item>
        <a-form-model-item label="环境地址" prop="url">
          <a-input v-model="ruleForm.url" placeholder="请输入http://和https://" :maxLength='100'></a-input>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal title='新建合同模板' width="600px" :visible="newContractVisible"
             @ok="handleContractOk"
             :confirm-loading="confirmLoading"
             @cancel="handleContractCancel">
      <a-form-model :label-col="{span:4}" :wrapper-col="{span:16}" ref="ruleContractForm" :model="ruleContractForm"
                    :rules="contractRules">
        <a-form-model-item label="模板类型" prop="contractTemplateType">
          <a-radio-group v-model='ruleContractForm.contractTemplateType' @change='handleTemplateChange'>
            <a-radio :value="2">普通合同</a-radio>
            <a-radio :value="1">对接全国旅游监督平台合同</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <div v-if='ruleContractForm.contractTemplateType==1'>
          <a-form-model-item label="合同类型" prop="contractTemplateId">
            <a-select allowClear v-model="ruleContractForm.contractTemplateId" placeholder="请选择">
              <a-select-option value="A00001">境内游</a-select-option>
              <a-select-option value="C00001">出境游</a-select-option>
              <a-select-option value="F00001">赴台游</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="有无购物" prop="hasShopping">
            <a-select allowClear v-model="ruleContractForm.hasShopping" placeholder="请选择">
              <a-select-option :value="1">有</a-select-option>
              <a-select-option :value="0">无</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="有无自费" prop="hasCost">
            <a-select allowClear v-model="ruleContractForm.hasCost" placeholder="请选择">
              <a-select-option :value="1">有</a-select-option>
              <a-select-option :value="0">无</a-select-option>
            </a-select>
          </a-form-model-item>
        </div>
      </a-form-model>
    </a-modal>

  </a-card>

</template>

<script>
import contractMixins from './contractMixins'
import CustomPdfViewer from '../../../../customComponents/CustomPdfViewer'
import searchForm from '@/utils/mixins/searchFormMixins'

export default {
  name: 'contractManagement',
  mixins: [contractMixins, searchForm],
  components: { CustomPdfViewer },
  data() {
    return {
      listType: 1,//1是合同，2是模版
      queryParams: {
        pactName: '',
        signName: ''
      },
      showMsgDialog: false,
      preViewPdfUrl: '',
      preViewDialogVisible: false,
      merchantId: '',
      platformId: '',
      templateId: 0,//当前的模版id
      msgList: [],
      selectedIndex: -1,
      sendLoading: false,
      sendPactId: undefined,
      settingVisible: false,
      confirmLoading: false,
      ruleForm: {
        appId: '',
        merchantAndPlatform: {
          merchantId: this.$store.getters.userInfo.merchantId,
          platformId: this.getPlatformConfig().platformId
        },
        signKey: '',
        url: ''
      },
      platformSettingRules: {
        appId: [
          { required: true, message: '请输入AppId', trigger: 'blur' },
          { pattern: /^[A-Za-z0-9]+$/, message: '请输入正确appId' }
        ],
        signKey: [
          { required: true, message: '请输入signKey', trigger: 'blur' },
          { pattern: /^[A-Za-z0-9]+$/, message: '请输入正确signKey' }
        ],
        url: [
          { required: true, message: '请输入http://和https://', trigger: 'blur' },
          { pattern: /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/, message: '请输入正确链接' }
        ]
      },
      newContractVisible: false,
      ruleContractForm: {
        //uploadSupervise:2,
        contractTemplateType: undefined,
        contractTemplateId: undefined,
        hasShopping: undefined,
        hasCost: undefined
        //activities:undefined,
      },
      contractRules: {
        contractTemplateType: [
          { required: true, message: '请选择模板类型', trigger: 'change' }
        ],
        contractTemplateId: [
          { required: true, message: '请选择合同类型', trigger: 'change' }
        ],
        hasShopping: [
          { required: true, message: '请选择有无购物', trigger: 'change' }
        ],
        hasCost: [
          { required: true, message: '请选择有无自费', trigger: 'change' }
        ]
      }
    }
  },
  created() {
    let userInfo = this.$store.getters.userInfo
    this.platformId = this.getPlatformConfig().platformId
    this.merchantId = userInfo.merchantId
    this.queryParams = {
      pactMerchantId: this.merchantId,
      pactPlatformId: this.platformId,
      pactName: '',
      signName: ''
    }
  },

  watch: {
    'listType': function(newVal, oldVal) {
      setTimeout(() => this.$refs.tableList.refresh(true), 500)
    },
    $route: function(to, form) {
      const listType = form.name === 'TemplateEditor' ? 2 : 1
      if (this.listType === listType) {
        if (to.name === 'ContractManager') {//重新进入当前页面，重新刷新数据
          setTimeout(() => this.$refs.tableList.refresh(true), 500)
        }
      } else {
        this.listTyp = listType
      }
    }
  },
  mounted() {

  },
  activated() {
    this.$store.commit('UPDATE_PAY_CONTRACT', true)
  },
  //运营商
  methods: {
    handleTemplateChange(e) {
      let value = e.target.value
      if (value == 2) {
        this.ruleContractForm = {
          contractTemplateType: value,
          contractTemplateId: undefined,
          hasShopping: undefined,
          hasCost: undefined
        }
      }
    },
    handleSettingOk() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.handleSubmit()
        } else {
          this.getLogUtils().logWithTag('错误', 'error submit!!')
          return false
        }
      })
    },
    handleSettingCancel() {
      this.settingVisible = false
    },
    onPlatformSettingEvent() {
      this.getSuperviseSet(1)
    },
    handleSubmit() {
      this.confirmLoading = true
      let params = JSON.parse(JSON.stringify(this.ruleForm))
      this.getHttpServices().getServerApiService().post('pact/saveSuperviseSet', params).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('保存成功')
        this.handleSettingCancel()
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.confirmLoading = false)
    },
    getSuperviseSet(type) {
      let params = {
        merchantId: this.merchantId,
        platformId: this.platformId
      }
      this.getHttpServices().getServerApiService().post('pact/getSuperviseSet', params)
        .then(res => {
          this.getLogUtils().logWithTag('getSuperviseSet', res)
          if (res && res.appId) {
            this.ruleForm = res
            if (type == 1) {
              this.settingVisible = true
            } else {
              if (this.ruleForm && this.ruleForm.appId && this.ruleForm.signKey && this.ruleForm.url) {
                let pageParams = this.getPageParams()
                setTimeout(() => {
                  this.openNewPage('TemplateEditor', { ...pageParams, ...this.ruleContractForm })
                }, 500)
              } else {
                this.$message.error('请先设置对接全国旅游服务监督平台信息')
              }
            }
          } else {
            this.settingVisible = true
          }
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    handleContractOk() {
      this.$refs.ruleContractForm.validate(valid => {
        if (valid) {
          this.getLogUtils().logWithTag('handleContractOk', this.ruleContractForm)
          this.newContractVisible = false
          let pageParams = this.getPageParams()
          let params = {}
          if (this.ruleContractForm.contractTemplateType == 2) {
            params = { contractTemplateType: this.ruleContractForm.contractTemplateType }
            this.openNewPage('TemplateEditor', { ...pageParams, ...params })
          } else {
            this.getSuperviseSet(2)
          }
        } else {
          this.getLogUtils().logWithTag('错误', 'error submit!!')
          return false
        }
      })
    },
    handleContractCancel() {
      this.newContractVisible = false
    },
    addContractEvent() {
      let pageParams = this.getPageParams()
      this.openNewPage('ContractCreator', { ...pageParams })
    },
    addTemplateEvent() {
      this.newContractVisible = true
      this.ruleContractForm = {
        contractTemplateType: undefined,
        contractTemplateId: undefined,
        hasShopping: undefined,
        hasCost: undefined
      }
    },
    //重发事件
    resendEvent(item) {
      this.getHttpServices().getServerApiService().post('pact/getPactSmsContent', { pactId: item.pactId })
        .then(list => {
          this.selectedIndex = 0
          this.msgList = list
          this.sendPactId = item.pactId
          this.showMsgDialog = true
          this.getLogUtils().logWithTag('resendEvent', list)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //复制短信内容
    copySmsContent(content) {
      this.$copyText(content).then(message => {
        this.$message.success('复制完毕')
      }).catch(err => {
        this.getLogUtils().logWithTag('copy.err', err)
        this.$message.error('复制失败')
      })
    },
    confirmSending(type) {
      if (type === 0) {
        this.showMsgDialog = false
        this.selectedIndex = 0
        this.msgList = []
      } else {
        const item = this.msgList[this.selectedIndex]
        let url = 'sms/sendPactRemind?signSort=' + item.signSort + '&pactId=' + this.sendPactId
        this.getHttpServices().getServerApiService().get(url, {})
          .then(res => {
            this.getLogUtils().logWithTag('resendEvent', res)
            this.$message.success('提醒发送成功！')
            this.showMsgDialog = false
            this.selectedIndex = -1
            this.msgList = []
          })
          .catch(reason => {
            this.$message.error('提醒发送失败！')
            this.getLogUtils().errorWithTag('resendEvent', reason)
          })
      }
    },
    //下载事件
    downLoadEvent(item) {
      window.open(item.pactPdfStreamUrl)
    },

    editTemplateEvent(record) {
      this.templateId = record.pactTemplateId
      let params = {
        id: record.pactTemplateId,
        contractTemplateType: record.pactTemplateType
      }
      let pageParams = this.getPageParams()
      this.openNewPage('TemplateEditor', { ...params, ...pageParams })
    },
    preViewContractEvent(record) {
      this.getLogUtils().logWithTag('preViewContractEvent==', record)
      if (this.listType === 2) {//模版
        this.preViewPdfUrl = record.pactTemplatePdfUrl
      } else {
        this.preViewPdfUrl = record.pactPdfStreamUrl
      }
      this.preViewDialogVisible = true
    },
    getRequestPromise(params) {
      let requestParams = {
        ...params,
        limitDto: undefined
      }
      const path = this.listType === 1 ? 'pact/getPactInfoList' : 'pact/getPactTemplateList'
      let url = path + '?pageNum=' + params.limitDto.pageNum + '&pageSize=' + params.limitDto.pageSize
      return new Promise((resolve, reject) => {
        this.getHttpServices().getServerApiService().post(url, requestParams)
          .then(res => {
            const result = {
              totalCount: res.pageResult.totalCount,
              pageCount: res.pageResult.pageCount,
              data: res.pageResult.data
            }
            resolve(result)
          }).catch(reason => reject(reason))
      })
    },
    copyTemplate(record) {
      this.getLogUtils().logWithTag('===copyTemplate==', record)
      let params = {
        merchantAndPlatform: {
          merchantId: this.merchantId,
          platformId: this.platformId
        },
        pactTemplateId: record.pactTemplateId
      }
      this.getHttpServices().getServerApiService().post('pact/copyPactTemplate', params)
        .then(res => {
          this.getLogUtils().logWithTag('resendEvent', res)
          this.$message.success('复制内容成功')
          this.onEventRefresh()
        })
        .catch(reason => {
          this.$message.error('复制内容失败')
          this.getLogUtils().errorWithTag('resendEvent', reason)
        })
    },
    onEventRefresh() {
      this.$refs.tableList.refresh(true)
    },
    getContractColumns() {
      return [
        {
          title: '合同号',
          dataIndex: 'pactId',
          width: '100px'
        },
        {
          title: '合同名称',
          dataIndex: 'pactName'
        },
        {
          title: '签署方1',
          dataIndex: 'pactMerchantName'
        },
        {
          title: '签署方2',
          dataIndex: 'pactMemberName'
        },
        {
          title: '创建时间',
          dataIndex: 'pactCreateTime'
        },
        {
          title: '签署时间',
          dataIndex: 'pactSignTime'
        },
        {
          title: '签署状态',
          dataIndex: 'pactSignStatus',
          scopedSlots: { customRender: 'pactSignStatus' }
        },
        {
          title: '合同编号',
          dataIndex: 'superviseCode'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '140px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    getTemplateColumns() {
      return [
        {
          title: '模版ID',
          dataIndex: 'pactTemplateId',
          width: '100px'
        },
        {
          title: '模版名称',
          dataIndex: 'pactTemplateName'
        },
        {
          title: '模板类型',
          dataIndex: 'pactTemplateTypeName'
        },
        {
          title: '创建时间',
          dataIndex: 'pactTemplateTime',
          width: '160px'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  }
}
</script>
<style scoped>
.inline-box {
  display: inline-block;
  margin-left: 40px;
}

.right-setting {
  height: 32px;
  line-height: 32px;
  text-align: right;
}
</style>
